import React, { useState } from 'react'
import EventCard from '../event-card/event-card'
import EventCardArticle from '../event-card-article/event-card-article'
import CardProduct from '../cardProduct/cardProduct'
import SessionService from '../../../services/session'
import ModalAuth from '../../molecules/modalAuth/modal-auth'
import useHomeLinkMode from '../../../hooks/useHomeLinkMode'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './others-events.scss'
import { useStaticQuery, graphql } from 'gatsby'
import useLocaleMode from '../../../hooks/useLocaleMode'
import { dataLayerUserInfo } from '../../../utils/userInfo'

const OthersEvents = ({ othersEvents, haveTitle = true, ...props }) => {
	const { locale } = useLocaleMode()

	const queryTitle = useStaticQuery(graphql`
		query QUERY_TITLE_EVENTS {
			allContentfulTenaAcademiaTena {
				nodes {
					ctaTePuedenInteresar
					node_locale
				}
			}
		}
	`)

	const titleSectionInterest =
		queryTitle &&
		queryTitle.allContentfulTenaAcademiaTena.nodes.filter(
			node => node.node_locale === locale
		)[0].ctaTePuedenInteresar

	const { homeLink } = useHomeLinkMode()
	const [isModalAuth, setIsModalAuth] = useState(false)
	const [activeEvent, setActiveEvent] = useState(null)

	const getFinalSlug = event => {
		const typeEvent = event.tipoDeEvento.toLowerCase()
		const baseSlug = homeLink + 'academia-tena/'

		if (typeEvent === 'live') {
			return baseSlug + 'lives/' + event.slug
		} else if (typeEvent === 'curso') {
			return baseSlug + 'cursos/' + event.slug
		} else {
			if (event.referenciasDeConferencistasLecciones?.length === 1) {
				return (
					baseSlug +
					'eventos/' +
					event.slug +
					event.referenciasDeConferencistasLecciones[0].slug
				)
			} else {
				return baseSlug + 'eventos/' + event.slug
			}
		}
	}
	const userInfo=dataLayerUserInfo()

	const handleRedirection = () => {
		const userData = SessionService.getUserData()
		const event = activeEvent

		if (event.esUnEventoExclusivo) {
			if (userData && userData !== null) {
				window.location.href = getFinalSlug(event)
			} else {
				setIsModalAuth(false)
			}
		} else {
			window.location.href = getFinalSlug(event)
		}
	}

	const sliderConf = {
		infinite: false,
		dots: othersEvents.length > 3,
		slidesToShow: 3,
		slidesToScroll: 1,
		className: 'f-other-events-slider',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					swipeToSlide: true,
					swipe: true,
					dots: true,
				},
			},
		],
	}

	React.useEffect(() => {
		if (isModalAuth) {
			setActiveEvent(isModalAuth)
		}
	}, [isModalAuth])

	console.log()

	return (
		<>
			<div className='f-others-events'>
				{haveTitle && (
					<h2 className='f-others-events__title'>{titleSectionInterest}</h2>
				)}
				<Slider {...sliderConf}>
					{othersEvents?.length > 0 &&
						othersEvents.map((event, index) => {
							if (event.id && event.tipoDelArticulo) {
								return (
									<EventCardArticle
										article={event}
										key={index}
										dataLayer={props.dataLayer}
									/>
								)
							} else if (event.tipoDeEvento) {
								return (
									<EventCard
										event={event}
										key={index}
										setIsModalAuth={setIsModalAuth}
										dataLayer={props.dataLayer}
									/>
								)
							} else {
								if (Object.keys(event).length > 0) {
									const params=(prod, index2)=>{			
										const par={
											event:'select_item',
											params:{	
												items: [{
													item_id: prod.codigoDeProducto,
													item_name: prod.nombreProducto,
													discount: 0,
													index: index2,
													item_list_name: prod.categorias?  prod.categorias[0].titulo ||'':'',
													item_list_id: prod.id,
													affiliation: 'Tena Online',
													item_category: prod.categorias?  prod.categorias[0].titulo ||'':'',
													item_brand: 'Tena',
													item_variant: prod.linea? prod.linea[0].nombreDeEtiqueta||'' : prod.categorias? prod.categorias[0].titulo :'',
													price: 0,
                                                	currency: process.env.LOCALE,
                                                	quantity: 1,
											
												}],
												item_list_name: prod.linea? prod.linea[0]?.nombreDeEtiqueta : undefined,
												item_list_id: prod.id,
												drip_degree: prod.tipoDeIncontinencia? prod.tipoDeIncontinencia[0].nombreDeEtiqueta: '',
												user_data: userInfo.user_data? userInfo.user_data :'',
												log_status: userInfo.log_status|| '',
												flow_type: "compra",
											}}
										return par
									}
									return (
										<CardProduct dataLayerbody={params(event,index)}
											isFreeSamples={false}
											modeAction={false}
											noHeight={false}
											noFooter={true}
											slug={event.slug}
											producto={event}
											key={index}
											samples={[]}
											idProduct={event.codigoDeProducto}
											isShortCard={true}
										/>
									)
								}
							}
							return <></>
						})}
				</Slider>
			</div>
			{isModalAuth && (
				<ModalAuth
					hideAction={() => {
						setIsModalAuth(false)
					}}
					validateCoverage={() => false}
					showModalCoverage={() => {
						handleRedirection()
					}}
					isWebinar={true}
					fromBenefits={false}
					title={
						<>
							Para acceder al contenido de <span>TENA,</span> debes ingresar a
							tu cuenta o registrarte.
						</>
					}
				/>
			)}
		</>
	)
}

export default OthersEvents
